//#region imports
import { Component, OnInit, HostListener, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute,NavigationStart } from '@angular/router';
import { CharacteristicService } from './services/characteristic.service';
import { Spinkit } from 'ng-http-loader';
import { empty, Subscription } from 'rxjs';
import { GuaranteeService } from './services/guarantee.service';
import { ContactDetailsResponseModel, ContactDetails } from './shared/model/save.model';
import { SaveService } from './services/save.service';
import { AppConstants } from './app.constants';
import { Location, LowerCasePipe } from '@angular/common';
import { ContactDetailsRequestModel } from './shared/model/contactdetails.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SignatureService } from './services/signature.service';
import { SignatureComponentModel } from './module/signature/model/signature.model';
import { DetailsService } from './services/details.service';
import { Globals } from 'src/app/services/globals';
import { DocumentService } from './services/document.service';
import { RetrieveSimulationService } from './services/retrieve-simulation.service';
import { SectionService } from './services/section.service';
import { CustomSpinnerComponent } from './shared/components/custom-spinner/custom-spinner.component';
//#endregion

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
  //#region variables
  contactDetailsResponse: ContactDetailsResponseModel;
  showLandingPage = false;
  spinnerStyle = Spinkit;
  customSpinComponent = CustomSpinnerComponent;
  clientId;
  simulationToken;
  thankyou;
  languageList = AppConstants.Languages.AllLanguages;
  defaultLanguage = AppConstants.Languages.DefaultLanguage;
  federaleURL = '';
  //AppConstants.FederaleURL.WWWFederale + this.defaultLanguage +(this.defaultLanguage==='FR')?'/particulier':'/particulieren';
  private clientIdSubscription: Subscription;
  isChrome: boolean;
  params: string='';
  subscription:Subscription;
  //#endregion

  //#region methods
  constructor(
    private router: Router, public translate: TranslateService, private route: ActivatedRoute,
    private characteristicService: CharacteristicService, private guaranteeService: GuaranteeService,
    private saveService: SaveService, private globals: Globals, private detailsService: DetailsService,
    private location: Location, private deviceService: DeviceDetectorService, private sectionService: SectionService,
    private signatureService: SignatureService, private documentService: DocumentService,
    private retrieveSimulationService: RetrieveSimulationService) {
      this.subscription = router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
    
          if(event.url!=='')
          if(!router.navigated && !event.url.toString().includes('/characteristics') && !event.url.toString().includes('thankyou') && !event.url.toString().includes('status') )
          {                
           this.router.navigate(['/characteristics']);                  
          }   
        }
       });     
    this.checkBrowser();
    this.checkDevice();
  }

  checkDevice() {
    this.globals.isMobile = this.deviceService.isMobile();
    this.globals.isTablet = this.deviceService.isTablet();
    this.globals.isDesktop = this.deviceService.isDesktop();
    // console.log('Mobile' + this.globals.isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // console.log('Tablet' + this.globals.isTablet);  // returns if the device us a tablet (iPad etc)
    // console.log('Desktop' + this.globals.isDesktop);
  }
  checkBrowser() {
    const browser = this.deviceService.getDeviceInfo().browser;
    // if (browser === 'Chrome') {
      this.isChrome = true;
    // } else {
    //   this.isChrome = false;
    // }
  }

  ngOnInit() {

    this.characteristicService.getDefaultLanguage().subscribe((value) => {
    
      if(value==='FR')
      {
        this.params='/particulier'
      }
      else if(value==='NL')
      {
        this.params='/particulieren'
      }
      this.federaleURL = AppConstants.FederaleURL.WWWFederale + value+ this.params;
        this.globals.federaleURL = this.federaleURL;

    });
   
    if (this.isChrome) {
      // sessionStorage.removeItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList);
      let sectionURl;
      this.translate.addLangs(this.languageList);
      const path = window.location.href; //this.location.path();
      const index = path.indexOf('?');
      index !== -1 ? sectionURl = path.substr(0, index) : sectionURl = path; 
      // console.log('sectionuri' + sectionURl);
      this.route.queryParams.subscribe((params) => {
        this.thankyou = params.thankyou ? params.thankyou : null;
        // console.log('thankyou' + params.thankyou);
        if(path.toLowerCase().indexOf("language=nl") >= 0){this.defaultLanguage = 'NL'} else {this.defaultLanguage = 'FR'}
        if(sessionStorage.getItem('language') != null){
          this.defaultLanguage = sessionStorage.getItem('language');
        }
        const languageUrl = params.language ? params.language : this.defaultLanguage;
        // console.log("paramlang"+ params.language);
        // console.log('deflang' + this.defaultLanguage);
        // this.setLanguage(languageUrl);
        // if (this.globals.languagecode == '' || this.globals.languagecode == undefined)
        //  {
        this.globals.languagecode = languageUrl.toUpperCase();
        //  }
        // console.log(path);
        if(sessionStorage.getItem('language') != null){
          sessionStorage.removeItem('language');
          sessionStorage.setItem('language', this.globals.languagecode);
        }else{sessionStorage.setItem('language', this.globals.languagecode);}
        this.translate.use(this.globals.languagecode); //this.translate.use(languageUrl.toUpperCase());
        console.log('app124:' + this.globals.languagecode);
        this.translate.setDefaultLang(this.globals.languagecode);
        this.characteristicService.setDefaultLanguage(this.globals.languagecode);
        this.guaranteeService.setLanguage(this.globals.languagecode);
        console.log('app131' + this.globals.languagecode)
        if(path.toLowerCase().indexOf("status") >= 0) {
        if(path.toLowerCase().indexOf("status=signed")=== -1){
            if(path.toLowerCase().indexOf("status=reject")!= -1 || path.toLowerCase().indexOf("status=invalidtoken")!= -1 ){
              const signatureComponent: SignatureComponentModel = {
                    SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
                    SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse: true
                  };
                  this.signatureService.setSignatureComponent(signatureComponent);
                  this.router.navigate(['/signature'], { queryParams: { thankyou: 'true', language: languageUrl, status: 'reject' } });
            }
          }else if(path.toLowerCase().indexOf("status=signed")!= -1){
              const signatureComponent: SignatureComponentModel = {
                SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
                SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: true, SignatureRefuse: false
              };
              this.signatureService.setSignatureComponent(signatureComponent);
              this.router.navigate(['/signature'], { queryParams: { thankyou: 'true', language: languageUrl, status: 'signed' } });
          } 
        }
        // if (sectionURl === '/signature' && this.thankyou === 'true'&& this.status.toUpperCase() === 'SIGNED') {
        //   const signatureComponent: SignatureComponentModel = {
        //     SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
        //     SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: true, SignatureRefuse: false
        //   };
        //   this.signatureService.setSignatureComponent(signatureComponent);
        //   this.router.navigate(['/signature'], { queryParams: { thankyou: 'true', language: languageUrl, status: this.status } });
        // } else if (sectionURl === '/signature' && this.thankyou === 'true' && this.status.toUpperCase() === 'REJECT') {
        //   const signatureComponent: SignatureComponentModel = {
        //     SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
        //     SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse: true
        //   };
        //   this.signatureService.setSignatureComponent(signatureComponent);
        //   this.router.navigate(['/signature'], { queryParams: { thankyou: 'true', language: languageUrl, status: this.status } });
        // }
        else {
          this.getPostalLocations();
          const executeClientIdOrSimulationTokenPresent = this.characteristicService.getExecuteChkClientIdOrSimulationTokenFirstTime();
          if (executeClientIdOrSimulationTokenPresent) {
            // this.translate.addLangs(this.languageList);
            this.translate.setDefaultLang(this.defaultLanguage);
            this.characteristicService.setDefaultLanguage(this.defaultLanguage);
            this.characteristicService.setFederaleURL(this.federaleURL);
            this.guaranteeService.setLanguage(this.defaultLanguage);
            this.getMaximumCapital();
            this.checkClientIdOrSimulationToken();
            this.characteristicService.getShowLandingPage().subscribe((value) => {
              this.showLandingPage = value;
              // console.log(this.showLandingPage);
            });
            if ((this.clientId === undefined && this.simulationToken === undefined) ||
              (path === '/details') || (path === '/guarantee') || (path === '/recapitulatory') || (path === '/signature')) {
              this.saveService.setSimulationStatus('Simulation in Progress');
              this.characteristicService.setCharacteristicProgressBarDetails();
              if(this.globals.isMobile)
              {this.characteristicService.setmobileCharacteristicProgressBarDetails();}
              this.router.navigate(['/characteristics']);
            }
          }
        }
      });
    }
  }

  getPostalLocations() {
    this.detailsService.getLocation().subscribe((data) => {
      this.globals.locationData = data;
    });
  }

  checkClientIdOrSimulationToken() {
    this.route.queryParams.subscribe(params => {
      const executeClientIdOrSimulationTokenPresent = this.characteristicService.getExecuteChkClientIdOrSimulationTokenFirstTime();
      if (executeClientIdOrSimulationTokenPresent) {
        this.clientId = params.clientId ? params.clientId : null;
        this.simulationToken = params.simulationToken ? params.simulationToken : null;
        const languageUrl = (params.language);
        this.setLanguage(languageUrl);
        if (this.clientId !== null || this.simulationToken !== null) {
          // this.characteristicService.setClientIdOrSimulationTokenPresent(true);
          this.globals.isClient = true;
          this.showLandingPage = true;
          this.federaleURL = AppConstants.FederaleURL.MyFederale + this.defaultLanguage;
          this.characteristicService.getDefaultLanguage().subscribe((value) => {          
             if (this.characteristicService.getClientIdOrSimulationTokenPresent()) {
               this.federaleURL = AppConstants.FederaleURL.MyFederale + value;
               this.characteristicService.setFederaleURL(this.federaleURL);              
             }
             else{
               let urlparam = "";
               if(this.globals.languagecode ==='FR') {
                 urlparam='/particulier'
               }else if(this.globals.languagecode ==='NL'){
                 urlparam='/particulieren' 
               }
               this.federaleURL = AppConstants.FederaleURL.WWWFederale + value + urlparam;
               this.characteristicService.setFederaleURL(this.federaleURL);
             }
          });

          
          this.characteristicService.setExecuteChkClientIdOrSimulationTokenFirstTime(false);
          if (this.clientId !== null) {
            this.sectionService.setClientIdPresent(true);
            this.characteristicService.setClientIdOrSimulationTokenPresent(true);
            // this.documentService.setAccountNumber(this.clientId);
            this.clientIdSubscription = this.characteristicService.getDecryptedClientIdAPI(this.clientId)
              .subscribe((value) => {
                this.characteristicService.setDecryptedClientId(value);
                this.getContactDetailsFromAPI(value, this.simulationToken);
                this.documentService.setAccountNumber(value);
                // console.log('ClientId:' + value);
              }, (error) => {
                  setTimeout (() => {
                    let input;
                    if(this.globals.languagecode === 'FR'){
                      input = {
                        title: 'Erreur inconnue', 
                        errorMessage: 'Nous ne pouvons pas accéder à votre demande dans l’immédiat, veuillez prendre contact avec l’un de nos bureaux ou l’infocentre au 0800 14 200 pour qu’ils vous assistent dans l’introduction de votre demande.', 
                        disableClose: true};
                    } else {
                    input = {
                      title: 'Onbekende fout', 
                      errorMessage: 'Wij kunnen uw verzoek niet verwerken. Neem contact op met één van onze kantoren of met het Info Center op 0800 14 200 zodat zij u verder kunnen helpen bij het indienen van uw aanvraag.', 
                      disableClose: true};}
                      this.characteristicService.serverFailError(input);
                 }, 100);
                //  const input = {
                //   title: this.translate.instant('Msg_UnexpectedError_Title'), 
                //   errorMessage: this.translate.instant('Msg_UnexpectedError_Message'), 
                //   disableClose: true}
              });
          } else if (this.simulationToken !== null) {
            this.sectionService.setClientIdPresent(false);
            const retrieveSimulationRequest: ContactDetailsRequestModel = {
              AccountNumber: null, SimulationToken: this.simulationToken
            };
            this.sectionService.setIsRetrieveSimulation(true);
            this.saveService.setSimulationToken(this.simulationToken);
            this.retrieveSimulationService.retrieveSimulationDetails(retrieveSimulationRequest);
          }
        } else {
          this.characteristicService.setClientIdOrSimulationTokenPresent(false);
          this.globals.isClient = false;
          this.showLandingPage = false;
        }
      }
    });
  }

  setLanguage(languageUrl) {
    if (languageUrl !== undefined) {
      languageUrl = languageUrl.toUpperCase();
      if (this.languageList.indexOf(languageUrl) !== -1) {
        this.defaultLanguage = languageUrl;
      } else {
        this.defaultLanguage = AppConstants.Languages.DefaultLanguage;
      }
      this.setDefaultLanguage(this.defaultLanguage);
      this.globals.languagecode = languageUrl;
    }
  }

  setDefaultLanguage(language) {
    this.translate.use(language);
    this.translate.setDefaultLang(language);
    console.log('app254:' + language);
    this.characteristicService.setDefaultLanguage(language);
    this.guaranteeService.setLanguage(language);
  }

  getMaximumCapital() {
    this.guaranteeService.getMaximumCapitalBatimentFromAPI().subscribe((maxCapitalResponse) => {
      this.guaranteeService.setMaximumCapitalBatiment(maxCapitalResponse.critereParamApplResponse.MontantAppl);
    });
  }

  getContactDetailsFromAPI(accountNumber, simulationToken) {
    const contactDetailsRequest: ContactDetailsRequestModel = {
      AccountNumber: accountNumber, SimulationToken: simulationToken
    };
    this.characteristicService.getContactDetailsFromAPI(contactDetailsRequest).subscribe((response) => {
      const accountDetails = response.AccountDetails;
      const contactDetails: ContactDetails = {
        FirstName: accountDetails.FirstName,
        Name: accountDetails.Name,
        LastName: accountDetails.LastName,
        EmailAddress: accountDetails.emailaddress,
        PostalCode: accountDetails.PostalCode,
        Telephone: accountDetails.telephone,
        DateofBirth: accountDetails.DateofBirth,
        StreetName:  accountDetails.StreetName,
        StreetNumber: accountDetails.StreetNumber,
        BoxNumber: accountDetails.BoxNumber
      };
      this.saveService.setContactDetails(contactDetails);
    });
  }

  btnSave() {
  }

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    // $event.returnValue = 'Are you sure?';
    const curpage = this.sectionService.getCurrentPage();
    if(curpage !== 'P5-5'){    
    sessionStorage.removeItem('jsonData');
    if (this.clientId === undefined && this.simulationToken === undefined) {      
      this.router.navigate(['/characteristics']);
    }
    }
  }
 
  ngOnDestroy() {
    if (this.clientIdSubscription) {
      this.clientIdSubscription.unsubscribe();
    }
  }
  //#endregion
}
